import service, { type HttpResponseSuccess } from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);

export const createPreTrialEmbeddedCheckoutSession = (): Promise<
	HttpResponseSuccess<{
		clientSecret: string;
	}>
> => {
	return apiService.get('/api/trial/createPreTrialEmbeddedCheckoutSession');
};

export const createReactivationEmbeddedCheckoutSession = (): Promise<
	HttpResponseSuccess<{
		clientSecret: string;
	}>
> => {
	return apiService.get(
		'/api/trial/createPreTrialEmbeddedCheckoutSession'
	);
};

export const stripeSuccessSubscription = (
	sessionId: string
): Promise<HttpResponseSuccess<unknown>> => {
	return apiService.post(`/api/trial/successSubscription`, {
		sessionId
	});
};
		